import { getApiClient } from 'adapter/out/client/apiClient';
import { ReportInstance } from 'domain/entity/reportInstance';
import CreateReportInstanceCriteria from 'use-case/reportInstance/create/createReportInstanceCritera';

const createReportInstanceApiClient = getApiClient(
    () => `dashboards/reports`,
    ReportInstance,
    (clientCriteria: CreateReportInstanceCriteria) => ({
        method: 'POST',
        body: JSON.stringify(parseCreateReportInstanceCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

const parseCreateReportInstanceCriteria = (criteria: CreateReportInstanceCriteria) => ({
    name: criteria.name,
    template_dashboard_id: criteria.templateId,
    context: {
        period: criteria.period,
        location_id: criteria.location,
        language: criteria.language,
        location_tags: criteria.locationTags.join(','),
    },
    visibility: {
        scope: criteria.scope,
        user_ids: criteria.userIds,
    },
});

export default createReportInstanceApiClient;
